import { useEffect } from "react";

export function useGlobalSlickAccessibilityFix() {
  useEffect(() => {
    const fixAccessibility = () => {
      const sliders = document.querySelectorAll(".slick-slider");

      sliders.forEach((slider) => {
        const slides = slider.querySelectorAll<HTMLElement>(".slick-slide");

        slides.forEach((slide) => {
          const isHidden = slide.getAttribute("aria-hidden") === "true";
          const focusableElements = slide.querySelectorAll<HTMLElement>(
            "a, button, input, select, textarea, [tabindex]"
          );

          focusableElements.forEach((el) => {
            if (isHidden) {
              el.setAttribute("tabindex", "-1");
            } else {
              el.setAttribute("tabindex", "0");
            }
          });
        });
      });
    };

    // Rodar o fix a cada 500ms para cobrir mudanças feitas pelo slick
    const interval = setInterval(fixAccessibility, 500);

    // Rodar imediatamente no mount também
    fixAccessibility();

    return () => clearInterval(interval);
  }, []);
}
